<coin-v2-dialog-frame [header]="header">
  <ng-template #header>
    @if (data.headline) {
      <h4
        data-testid="confirm-dialog-headline"
        class="dialog-title">
        {{ data.translate ? (data.headline | translate) : data.headline }} {{ getHeadlineData() }}
      </h4>
    }
  </ng-template>

  <div class="container">
    <div class="content">
      <div class="body-container">
        @if (!data.headline) {
          <h4 data-testid="confirm-dialog-msg">
            {{ data.translate ? getTranslatedValue(data.msg) : data.msg }}
          </h4>
        }
        @if (data.headline && data.msg) {
          <p
            class="msg"
            data-testid="confirm-dialog-msg"
            [innerHtml]="data.translate ? getTranslatedValue(data.msg) : data.msg"></p>
        }
        <!-- The optional controls are deferred: most dialogs show none, and the date picker alone is ~90 KB. -->
        @if (data?.dropdownValues?.length) {
          @defer (on immediate) {
            @if (data?.dropdownWithSearch) {
              <coin-v2-dropdown
                #search="dropdownSearch"
                required
                style="width: 100%; margin: 10px 0"
                [placeholder]="($safeNavigationMigration(data?.placeholderText) | translate) ?? '...'"
                [label]="$safeNavigationMigration(data?.dropdownLabel)"
                [dataSource]="data.dropdownValues"
                [(ngModel)]="selectedDropdownValue">
                @for (item of search.results(); track item) {
                  <ng-template [coinValue]="item">
                    {{ (data?.dropdownDisplayFn || dropdownDisplayFn)(item, $index) }}
                  </ng-template>
                }
              </coin-v2-dropdown>
            } @else {
              <coin-v2-dropdown
                required
                style="width: 100%; margin: 10px 0"
                [placeholder]="($safeNavigationMigration(data?.placeholderText) | translate) ?? '...'"
                [label]="$safeNavigationMigration(data?.dropdownLabel)"
                [(ngModel)]="selectedDropdownValue">
                @for (item of data.dropdownValues; track item) {
                  <ng-template [coinValue]="item">
                    {{ (data?.dropdownDisplayFn || dropdownDisplayFn)(item, $index) }}
                  </ng-template>
                }
              </coin-v2-dropdown>
            }
          }
        }
        @if (data.multilineInput) {
          @defer (on immediate) {
            <coin-v2-text-area
              class="comment-text"
              [placeholder]="($safeNavigationMigration(data?.placeholderText) | translate) ?? '...'"
              [rows]="4"
              [disabled]="$safeNavigationMigration(data?.inputReadOnly)"
              [(ngModel)]="providedInput"></coin-v2-text-area>
          }
        }

        @if (data?.provideInput && !data.multilineInput && !data.dateInput) {
          <div class="comment-text">
            <input
              title="text"
              name="text"
              id="text"
              [placeholder]="($safeNavigationMigration(data?.placeholderText) | translate) ?? '...'"
              [type]="data.inputType || 'text'"
              [readOnly]="$safeNavigationMigration(data?.inputReadOnly)"
              [(ngModel)]="providedInput" />
          </div>
        }
        @if (data?.provideInput && !data.multilineInput && data.dateInput) {
          <div class="comment-text">
            @defer (on immediate) {
              <coin-v2-date-input
                [placeholder]="($safeNavigationMigration(data?.placeholderText) | translate) ?? '...'"
                [(ngModel)]="providedInput"></coin-v2-date-input>
            }
          </div>
        }

        @if (data?.dateInputs?.length) {
          <div class="comment-text date-inputs">
            @defer (on immediate) {
              @for (dateInput of data.dateInputs; track $index) {
                <coin-v2-date-input
                  [placeholder]="($safeNavigationMigration(data?.placeholderText) | translate) ?? '...'"
                  [formControl]="dateInput.control"
                  [label]="dateInput.label | translate"></coin-v2-date-input>
              }
            }
          </div>
        }

        @if (data?.noteText) {
          <div class="sub-text">
            <mat-icon>warning</mat-icon>
            <p>
              {{ data.translate ? (data.noteText | translate) : data.noteText }}
            </p>
          </div>
        }

        @if (data?.provideCheckbox) {
          @defer (on immediate) {
            <coin-v2-checkbox
              class="confirm-checkbox"
              data-testid="confirm-dialog-checkbox"
              [label]="data.translate ? (data.checkboxLabel | translate) : data.checkboxLabel"
              [(ngModel)]="checkboxChecked"></coin-v2-checkbox>
          }
        }
      </div>
    </div>

    <coin-v2-dialog-footer
      color="white"
      padding="none">
      @if (data.thirdButtonMsg) {
        <coin-v2-button
          type="secondary"
          [icon]="thirdButtonIcon"
          [text]="data.translate ? (data.thirdButtonMsg | translate) : data.thirdButtonMsg"
          [disabled]="data?.inputMandatory ? !(data.dateInput ? providedInput : $any(providedInput)?.trim()) : false"
          (click)="onThirdButtonClick()"></coin-v2-button>
      }
      <div class="v2-footer-spacer"></div>
      @if (data.cancelMsg) {
        <coin-v2-button
          type="secondary"
          data-testid="confirm-dialog-cancel"
          [icon]="cancelButtonIcon"
          [text]="data.translate ? (data.cancelMsg | translate) : data.cancelMsg"
          (click)="cancel()"></coin-v2-button>
      }
      <coin-v2-button
        type="primary"
        data-testid="confirm-dialog-confirm"
        [icon]="confirmButtonIcon"
        [text]="data.translate ? (data.confirmMsg | translate) : data.confirmMsg"
        [disabled]="confirmDisabled"
        (click)="confirm()"></coin-v2-button>
    </coin-v2-dialog-footer>
  </div>
</coin-v2-dialog-frame>
